import { gql } from 'graphql-request';

import {
  FRAGMENT_COMPLEX_FIELDS_RENTAL_PREVIEW,
  FRAGMENT_COMPLEX_FIELDS_SALE_CORE,
  FRAGMENT_COMPLEX_FIELDS_SALE_PREVIEW,
  FRAGMENT_LISTING_DETAILS_MEDIA,
  FRAGMENT_LISTING_DETAILS_PREVIEW,
  FRAGMENT_LISTING_MEDIA,
  FRAGMENT_MSA_PREVIEW,
  FRAGMENT_PROPERTY_DETAILS_PREVIEW,
} from '@hcs/cerberus';
import { FRAGMENT_PROPERTY_LOCATION } from '@hcs/cerberus';

const FRAGMENT_PROPERTY_SPATIAL_DETAIL_RESULTS_MAP = gql`
  ${FRAGMENT_PROPERTY_LOCATION}
  ${FRAGMENT_COMPLEX_FIELDS_SALE_CORE}
  ${FRAGMENT_COMPLEX_FIELDS_RENTAL_PREVIEW}
  ${FRAGMENT_MSA_PREVIEW}
  fragment PropertySpatialDetailResultsMap on SpatialSearchDetailResults {
    __typename
    atEnd
    cursor
    totalCount
    hits {
      propertyDetails {
        hcAddressId
        location {
          ...PropertyLocation
        }
        msaDetails {
          ...MsaPreview
        }
      }
      complexFields {
        sale {
          ...ComplexFieldsSaleCore
        }
        rental {
          ...ComplexFieldsRentalPreview
        }
      }
    }
  }
`;

const FRAGMENT_PROPERTY_SPATIAL_DETAIL_RESULTS_LIST = gql`
  ${FRAGMENT_PROPERTY_LOCATION}
  ${FRAGMENT_PROPERTY_DETAILS_PREVIEW}
  ${FRAGMENT_COMPLEX_FIELDS_SALE_PREVIEW}
  ${FRAGMENT_COMPLEX_FIELDS_RENTAL_PREVIEW}
  ${FRAGMENT_LISTING_DETAILS_PREVIEW}
  ${FRAGMENT_LISTING_MEDIA}
  ${FRAGMENT_LISTING_DETAILS_MEDIA}
  ${FRAGMENT_MSA_PREVIEW}
  fragment PropertySpatialDetailResultsList on SpatialSearchDetailResults {
    __typename
    atEnd
    cursor
    totalCount
    hits {
      propertyDetails {
        hcAddressId
        location {
          ...PropertyLocation
        }
        hc {
          property {
            ...PropertyDetailsPreview
          }
        }
        msaDetails {
          ...MsaPreview
        }
      }
      complexFields {
        sale {
          ...ComplexFieldsSalePreview
        }
        rental {
          ...ComplexFieldsRentalPreview
        }
      }
      latestListing {
        sale {
          ...ListingDetailsPreview
          media {
            hc {
              ...ListingMedia
            }
          }
        }
        rental {
          ...ListingDetailsPreview
        }
      }
    }
  }
`;

export const QUERY_PROPERTY_SPATIAL_SEARCH_LIST = gql`
  ${FRAGMENT_PROPERTY_SPATIAL_DETAIL_RESULTS_LIST}
  query PropertySpatialSearchList(
    $id: SpatialSortPropertiesIdentifierInput!
    $limit: Int!
    $cursor: String
    $sort: SpatialSortInput
    $spatialFilters: SpatialSortFiltersInput!
  ) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: aexp-product-access
    # HC CAPABILITY: pexp-product-access
    propertySpatialESSearch(
      id: $id
      limit: $limit
      sort: $sort
      pagination: { paginate: true, cursor: $cursor }
      spatialFilters: $spatialFilters
    ) {
      ... on SpatialSearchDetailResults {
        ...PropertySpatialDetailResultsList
      }
    }
  }
`;

export const QUERY_PROPERTY_SPATIAL_SEARCH_MAP = gql`
  ${FRAGMENT_PROPERTY_SPATIAL_DETAIL_RESULTS_MAP}
  query PropertySpatialSearchMap(
    $id: SpatialSortPropertiesIdentifierInput!
    $limit: Int!
    $spatialFilters: SpatialSortFiltersInput!
  ) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: aexp-product-access
    # HC CAPABILITY: pexp-product-access
    propertySpatialESSearch(
      id: $id
      limit: $limit
      countLimit: { type: AUTO }
      spatialFilters: $spatialFilters
    ) {
      __typename
      ... on SpatialSearchDetailResults {
        ...PropertySpatialDetailResultsMap
      }
      ... on SpatialSearchCountResult {
        count
        labelLocation(format: DICT)
      }
      ... on SpatialSearchOverCountResult {
        moreThan
        labelLocation(format: DICT)
      }
    }
  }
`;

export const QUERY_PROPERTY_SPATIAL_SEARCH_COUNT = gql`
  query PropertySpatialSearchCount(
    $id: SpatialSortPropertiesIdentifierInput!
    $spatialFilters: SpatialSortFiltersInput!
  ) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: aexp-product-access
    # HC CAPABILITY: pexp-product-access
    propertySpatialESSearch(
      id: $id
      pagination: { paginate: false }
      spatialFilters: $spatialFilters
    ) {
      __typename
      ... on SpatialSearchCountResult {
        count
      }
      ... on SpatialSearchOverCountResult {
        moreThan
      }
    }
  }
`;
